import {
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import { componentDestroyed } from 'ng2-rx-componentdestroyed';
import {
  share,
  takeUntil,
} from 'rxjs/operators';

import { CommonService } from '@services/common.service';
import { ProfileService } from '@services/profile.service';
import { YTBSEOService } from '@services/ytb-seo.service';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-emailUnSubscribe',
    templateUrl: './emailUnSubscribe.component.html',
    providers: []
})
export class EmailUnSubscribeComponent implements OnInit {
      private destroyRef = inject(DestroyRef);
    
    isLoading: boolean = false;
    userNotFounfShowFail: boolean = false;
    userNotFoundShowSuccess: boolean = false;
    userNotFoundMessageInfo: any = {};


    userUpdateShowFail: boolean = false;
    userUpdateShowSuccess: boolean = false;

    unsubscribedInformation: Array<any> = [];
    subscribeInformation: any = {};
    allSubscriptionTypes: Array<any> = [];
    subscriptionId: number = 0;
    emailId: string = "";

    updateStatusRequest: any = {};
    queryParamEmailId: string = "";
    unsubscribeForm: UntypedFormGroup;

    constructor(
        private commonService: CommonService, private route: ActivatedRoute, private profile: ProfileService, private router: Router, private ytbseo: YTBSEOService) { }

        
    ngOnInit() {
        this.unsubscribeForm = new UntypedFormGroup({
            bookingId: new UntypedFormControl(null, [Validators.required, this.spaceValidator.bind(this),Validators.email])
          });

        this.route.queryParams.subscribe(res => {
            // let urls = this.router.url.split('?');
            // setTimeout(() => {

            //     this.ytbseo.createCanonicalURL(this.router.url);
            //     this.ytbseo.setDynamicTitle(urls[0]);           
            // }, 2000);

            if (res && Object.keys(res).length != 0) {
                this.queryParamEmailId = res.emailId;
                this.emailId = this.queryParamEmailId;
                this.unsubscribeForm.controls['bookingId'].setValue(this.emailId);
                this.geEmailSubscriptionMappingForEmail(true);
            } else {
                // this.router.navigate(["error"]);
                this.isLoading=false;
            }
        });


        // this.queryParamEmailId = this.queryParamEmailId ? this.queryParamEmailId : "dGVzdEBnbWFpbC5jb20=";

        this.profile.getAllSubscriptionTypes();

        this.profile.ALLSUBSCRIPTIONDETAILSSUCCESS.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            if (res) {
                if (res.successCode) {

                    this.allSubscriptionTypes = res.result;
                } else {

                    this.allSubscriptionTypes = [];
                }
                //console.log('allSubscriptionTypes', this.allSubscriptionTypes);
            }
        });



        this.profile.UPDATEUSERSUBSCRIBINGMAPPINGDETAILSSUCCESS.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            if (res) {
                this.userNotFounfShowFail = false;
                this.isLoading = false;
                this.userNotFoundMessageInfo = res.messageInfo;
                if (res.successCode) {
                    this.userUpdateShowSuccess = true;
                    this.isLoading = false;
                    setTimeout(() => {
                        this.userUpdateShowSuccess = false;
                        this.geEmailSubscriptionMappingForEmail(false);
                    }, 3000);
                } else {
                    this.userNotFounfShowFail = true;
                }
            }
        });

        this.profile.GETUSERSUBSCRIBEDMAPPINGDETAILSSUCCESS.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            if (res) {
                console.log(JSON.stringify(res));
                this.isLoading = false;
                this.userNotFounfShowFail = false;

                this.userNotFoundMessageInfo = res.messageInfo;
                if (res.successCode) {
                    this.userNotFoundShowSuccess = true;

                    this.unsubscribedInformation = res.result.activeSubscriptions;
                    this.subscribeInformation = res.result;
                    this.subscriptionId = res.result.subscriptionId;

                    this.emailId = res.result.emailId;
                    this.unsubscribeForm.controls['bookingId'].setValue(this.emailId);
                    //console.log(JSON.stringify(this.unsubscribedInformation));
                } else {
                    this.userNotFounfShowFail = true;
                }
            }
        });
    }


    geEmailSubscriptionMappingForEmail(isLoad: boolean) {
            this.resetValues();
            this.isLoading = isLoad;
            this.profile.getEmailSubscriptionMappingforEmail({ 'emailId': this.unsubscribeForm.controls['bookingId'].value });
    }


    updateMappingStatus() {
        if (this.unsubscribeForm.valid) {

        this.resetValues();
        this.isLoading = true;
        this.updateStatusRequest.activeMappings = this.unsubscribedInformation;
        this.updateStatusRequest.emailId = this.unsubscribeForm.controls['bookingId'].value;
        this.updateStatusRequest.subscriptionId = this.subscriptionId;

        this.profile.updateEmailSubscriptionMappingforEmail(this.updateStatusRequest);

        console.log(JSON.stringify(this.unsubscribedInformation));
    }
    else{
        this.commonService.validateAllFormFields(this.unsubscribeForm)
    }
    }

    ngOnDestroy() {
        this.commonService.dispose();
    }


    resetValues() {
        this.userNotFounfShowFail = false;
        this.userNotFoundShowSuccess = false;
        this.userNotFoundMessageInfo = {};
        this.userUpdateShowFail = false;
        this.userUpdateShowSuccess = false;

    }
    spaceValidator(dateOfBirthVal: AbstractControl) {
        let nameValue = dateOfBirthVal.value;
        if (nameValue) {
          if (nameValue) {
            let indexValue = nameValue.indexOf(' ');
            if (indexValue >= 0) {
              return { space: true };
            } else {
              return null;
            }
          }
        }
        return null;
      }
}